import { Box, Container, Stack } from '@mui/material';

import { ResetPassword as ResetPasswordView } from '@modules/Auth/views';

export const ResetPassword = () => {

  return (
    <Stack height="100vh" justifyContent="center">
      <Box py={6}>
        <Container maxWidth="md">
          <ResetPasswordView />
        </Container>
      </Box>
    </Stack>
  );
};
